import React, { useState, useEffect } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import db from "../../../../db/index.json";
import ImageTag from "../../../reusebale/imageTag";
import { ArrowRight } from "lucide-react";
import BaseUrl from "../../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import TransactionsList from "../../home/transactionsList";

const ReceivePayment = ({ handleTenantTable, leaseDetails, onViewAllTransactions }) => {
  const { rightPanel } = db;
  const { loginSuccess } = useSelector((state) => state.auth);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Check if we should show dynamic transactions (active lease)
  const isActiveLease = leaseDetails && leaseDetails.status === "active";

  useEffect(() => {
    if (isActiveLease && leaseDetails._id) {
      fetchTransactions();
    }
  }, [leaseDetails?._id, isActiveLease]);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${BaseUrl}api/payment-transaction/lease/${leaseDetails._id}`,
        requestOptions
      );

      const result = await response.json();

      if (result.status === "success" && result.data) {
        // Sort by createdAt descending
        const sortedTransactions = result.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTransactions(sortedTransactions);
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleViewAll = () => {
    if (onViewAllTransactions && isActiveLease) {
      onViewAllTransactions(leaseDetails._id);
    } else if (handleTenantTable) {
      handleTenantTable();
    }
  };

  return (
    <div className="bg-white rounded-2xl py-5 px-4 w-full mt-5 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
      <div className="flex justify-between items-center ">
        <ParagraphTag
          content="Payments"
          classes="text-darkColor font-popinsSemiBold text-xl"
        />
        {(onViewAllTransactions || handleTenantTable) && (
          <ParagraphTag
            content={rightPanel.viewall}
            classes="text-themeColor font-popinsSemiBold text-sm cursor-pointer"
            onTrigger={handleViewAll}
          />
        )}
      </div>

      {isActiveLease ? (
        // Dynamic transaction view for active leases - limit to 5
        <TransactionsList
          transactions={transactions}
          loading={loading}
          leaseDetails={leaseDetails}
          limit={5}
          showHeaders={true}
        />
      ) : (
        // Static view for non-active leases or when leaseDetails is not provided
        <>
          <div className="flex border-b-[1px] border-darkColor/40 pb-1 mt-6">
            <div className="w-[40%]">
              <ParagraphTag
                content={rightPanel.tenants}
                classes="text-darkColor/40 font-popinsMedium text-sm"
              />
            </div>
            <div className="w-[25%] pl-3">
              <ParagraphTag
                content={rightPanel.rent}
                classes="text-darkColor/40 font-popinsMedium text-sm"
              />
            </div>
            <div className="w-[15%] pl-3">
              <ParagraphTag
                content={rightPanel.rent}
                classes="text-darkColor/40 font-popinsMedium text-sm"
              />
            </div>
            <div className="w-[20%] text-end">
              <ParagraphTag
                content={rightPanel.quick}
                classes="text-darkColor/40 font-popinsMedium text-sm"
              />
            </div>
          </div>
          <div className="h-[220px] overflow-y-scroll panelScroll">
            {rightPanel.paymentTable.map((item, i) => (
              <div key={i} className="flex mt-4 justify-between">
                <div className="w-[40%] flex items-center">
                  <div className="w-[16%]">
                    <ImageTag
                      path="/assets/daashboard/price.png"
                      classes="w-full"
                      altText="login"
                    />
                  </div>
                  <div className="w-[84%] pl-3">
                    <ParagraphTag
                      content={item.rowDesc}
                      classes="text-darkColor/40 font-popinsMedium text-xs"
                    />
                    <ParagraphTag
                      content={item.rowName}
                      classes="text-darkColor font-popinsSemiBold text-sm"
                    />
                  </div>
                </div>
                <div className="w-[26%] flex items-center justify-center">
                  <ParagraphTag
                    content={item.timeDate}
                    classes="text-darkColor font-popinsMedium text-sm pl-2"
                  />
                </div>
                <div className="w-[15%]">
                  <ParagraphTag
                    content={item.price}
                    classes="text-darkColor font-popinsMedium text-sm pl-2"
                  />
                </div>
                <div className="w-[19%] flex justify-center items-center">
                  <div className="flex justify-center items-center bg-themeColor w-[35%] h-8 rounded-lg cursor-pointer">
                    <ArrowRight color="#FFFFFF" size={20} strokeWidth={2} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ReceivePayment;
